import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields('nodes', [
      'date',
      'draggingItem',
      'draggedOverId',
    ]),
  },
  methods: {
    dragStart(event) {
      this.isDragging = true;
      this.draggingItem = {
        ...this.item,
      };
    },
    dragOver(event) {
      event.preventDefault();
      this.draggedOverId = this.item.id;
    },
    dragEnter(event) {
      this.draggedOverId = this.item.id;
    },
    dragLeave(event) {
      this.draggedOverId = null;
    },
    dragEnd(event) {
      this.draggedOverId = null;
      this.isDragging = false;
      this.draggingItem = null;
    },
    drop(event) {
      event.preventDefault();
      if (!this.item._allowDropInGroup) {
        this.addNode({ from: this.item.id });
      } else {
        if (this.isDefault) {
          return false;
        }

        this.swapNodes({ id: this.item.id });
      }
    },
  }
};
